// externals
import type { FC } from 'react';
import React, { useEffect } from 'react';

export const Logout: FC<{ handleLogout: () => void }> = ({ handleLogout }) => {
    useEffect(() => {
        handleLogout();
    }, []);
    return <>Logging out...</>;
};
